<form name="addLocationForm" #addLocationForm="ngForm">
    <div mat-dialog-title class="modal-header">
        <button type="button" class="close close-btn" *ngIf="!createLocationButtonLoader" aria-label="Close"
            mat-dialog-close (click)="resetLocationForm(addLocationForm);clearLocationData()"><i
                class="fa fa-close"></i></button>
        <h4 class="modal-title">Create Location</h4>
    </div>

    <mat-dialog-content>
        <div class="modal-body">
            <div class="member-card">
                <h4 class="filter-options">Address Details</h4>
                <hr class="hr-class" />
                <div class="col-md-12">
                    <div class="row">
                        <input type="text" #pick id="reusableAutocompleteAddress" class="form-control mb-4"
                            [(ngModel)]="searchedAddr" name="searchAddr" (ngModelChange)="autoSearchAddress()"
                            placeholder="Search">
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-md-12">
                        <label>Location Name</label><span class="text-danger"> * </span>
                        <input type="text" name="addressName" #addressName="ngModel" id="addressName"
                            [(ngModel)]="Location.addressName" placeholder="Location Name" class="form-control"
                            maxlength="255"
                            [ngClass]="{ 'is-invalid': addLocationForm.submitted && addressName.invalid }" required />
                        <div *ngIf="addLocationForm.submitted && addressName.invalid" class="invalid-feedback">
                            <div *ngIf="addressName.errors.required"><span class="text-danger">Location Name is
                                    required.</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Address Type</label><span class="text-danger"> * </span>
                            <select name="addressType" #addressType="ngModel" class="form-control"
                                [(ngModel)]="Location.LocationAddressType"
                                [ngClass]="{ 'is-invalid': addLocationForm.submitted && addressType.invalid }" required>
                                <option [value]="null" selected disabled>Select Address Type</option>
                                <option *ngFor="let item of AddressType" [value]="item" name="addr_type">
                                    {{item}}
                                </option>
                            </select>
                            <div *ngIf="addLocationForm.submitted && addressType.invalid" class="invalid-feedback">
                                <div *ngIf="addressType.errors.required"><span class="text-danger">Address Type is
                                        required.</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Address</label><span class="text-danger"> * </span>
                            <div class="radio my-0">
                                <label>
                                    <input type="radio" name="pvtOrPublic" #pvtOrPublic="ngModel"
                                        [(ngModel)]="Location.isGlobal" [value]="false"
                                        (click)="Location.airportCode = null" />Private
                                </label>
                                <label class="ml-4">
                                    <input type="radio" name="pvtOrPublic" #pvtOrPublic="ngModel"
                                        [(ngModel)]="Location.isGlobal" [value]="true"
                                        (click)="Location.airportCode = null" />Public
                                </label>
                                <label class="ml-4">
                                    <input type="radio" name="pvtOrPublic" #pvtOrPublic="ngModel"
                                        [(ngModel)]="Location.isGlobal" [value]="null" />Airport
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row form-group" *ngIf="Location.isGlobal == null">
                    <div class="col-md-6">
                        <label>Airport Code </label><span class="text-danger"> * </span>
                        <button type="button" id="addAirportCode" (click)="isShowAddAirportCode = true"
                            class="plus-icon" *ngIf="!isShowAddAirportCode" title="Add Airport Code">
                            <i class="fa fa-plus-circle "></i>
                        </button>
                        <button type="button" class="plus-icon" title="Cancel Add Airport Code"
                            *ngIf="isShowAddAirportCode" (click)="isShowAddAirportCode = false; airport=''">
                            <i class="fa fa-times-circle"></i>
                        </button>
                        <div *ngIf="isShowAddAirportCode">
                            <div class="col-md-8 px-0">
                                <input type="text" class="form-control" placeholder="Enter Airport Code"
                                    name="airportCodeName" #airportCodeName="ngModel" [(ngModel)]="airport"
                                    [value]="airport | uppercase" minlength="3" maxlength="4" required>
                            </div>
                            <div class="col-md-4 pr-0">
                                <button class="flat-butt flat-info-butt flat-info-grad-butt btn-size save-btn col-md-12"
                                    type="button" (click)="addAirportCode()">
                                    Save
                                </button>
                            </div>
                        </div>
                        <select *ngIf="!isShowAddAirportCode" name="airportCode" #airportCode="ngModel"
                            class="form-control" [(ngModel)]="Location.airportCode"
                            [ngClass]="{ 'is-invalid': addLocationForm.submitted && airportCode.invalid }" required>
                            <option [value]="null" selected disabled>Select Airport Code</option>
                            <option *ngFor="let item of airportCodeList" [value]="item.airportCode" name="state">
                                {{item?.airportCode}}
                            </option>
                        </select>
                      <!---todo commented as airportCode is not exist-->
                        <!--<div *ngIf="addLocationForm.submitted && airportCode && airportCode.invalid"
                            class="invalid-feedback">
                            <div *ngIf="airportCode.errors.required">
                                <span class="text-danger">
                                    Airport Code is required.
                                </span>
                            </div>
                        </div>-->
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-md-6">
                        <label>Street Address</label><span class="text-danger"> * </span>
                        <input type="text" name="streetAddress" #streetAddress="ngModel" id="aContact_StreetAddress"
                            [(ngModel)]="Location.streetAddress" placeholder="Street Address" class="form-control"
                            maxlength="150" pattern="^[^\s]+(\s+[^\s]+)*$"
                            [ngClass]="{ 'is-invalid': addLocationForm.submitted && streetAddress.invalid }" required />
                        <div *ngIf="addLocationForm.submitted && streetAddress.invalid" class="invalid-feedback">
                            <div *ngIf="streetAddress.errors.required"><span class="text-danger">Street Address is
                                    required.</span>
                            </div>
                            <div *ngIf="streetAddress.errors.pattern"><span class="text-danger">Street Address
                                    not valid.</span></div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label>Zipcode</label><span class="text-danger"> * </span>
                        <input type="text" id="acZipCode" placeholder="Zipcode" name="Zipcode" #Zipcode="ngModel"
                            [(ngModel)]="Location.zipcode" class="form-control" minlength="3" maxlength="5"
                            [ngClass]="{ 'is-invalid': addLocationForm.submitted && Zipcode.invalid }"
                            pattern="[A-Za-z0-9]+" required />
                        <div *ngIf="addLocationForm.submitted && Zipcode.invalid" class="invalid-feedback">
                            <div *ngIf="Zipcode.errors.required"><span class="text-danger">Zipcode is
                                    required.</span>
                            </div>
                            <div *ngIf="Zipcode.errors.minlength"><span class="text-danger">Zipcode must
                                    have 3 or 5 digits.</span></div>
                            <div *ngIf="Zipcode.errors.pattern"><span class="text-danger">Zipcode
                                    not valid.</span></div>
                        </div>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-md-6">
                        <label>State </label><span class="text-danger"> * </span>
                        <select name="state" #state="ngModel" class="form-control" [(ngModel)]="Location.stateId"
                            (change)="getCityByState(Location.stateId)"
                            [ngClass]="{ 'is-invalid': addLocationForm.submitted && state.invalid }" required>
                            <option value="" selected disabled>Select State</option>
                            <option *ngFor="let item of stateList" [value]="item.stateId" name="state">
                                {{item?.stateName}}
                            </option>
                        </select>
                        <div *ngIf="addLocationForm.submitted && state.invalid" class="invalid-feedback">
                            <div *ngIf="state.errors.required"><span class="text-danger">State is
                                    required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label>City</label><span class="text-danger"> * </span>
                        <button type="button" id="addLocationPopUp" (click)="isShowAddCity=true" class="plus-icon"
                            *ngIf="isCityButtonShow && !isShowAddCity" title="Add City">
                            <i class="fa fa-plus-circle "></i>
                        </button>
                        <button type="button" class="plus-icon" title="Cancle Add City" *ngIf="isShowAddCity"
                            (click)="isShowAddCity=!isShowAddCity;cityAdd.cityName=''">
                            <i class="fa fa-times-circle"></i>
                        </button>
                        <div *ngIf="isShowAddCity">
                            <form name="cityform" #cityform="ngForm">
                                <div class="col-md-8 px-0"><input type="text" class="form-control"
                                        placeholder="Enter City Name" name="city" #city="ngModel"
                                        [(ngModel)]="cityAdd.cityName"
                                        [ngClass]="{ 'is-invalid': cityform.submitted && city.invalid }" required>
                                    <div *ngIf="cityform.submitted && city.invalid" class="invalid-feedback">
                                        <div *ngIf="city.errors.required"><span class="text-danger">Enter City
                                                name.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 pr-0">
                                    <button
                                        class="flat-butt flat-info-butt flat-info-grad-butt btn-size save-btn col-md-12"
                                        type="submit" (click)="addCity()"> Save </button>
                                </div>
                            </form>
                        </div>
                        <select name="city" #city="ngModel" class="form-control"
                            [ngClass]="{ 'is-invalid': addLocationForm.submitted && state.invalid }" required
                            [(ngModel)]="Location.cityId" *ngIf="!isShowAddCity">
                            <option value="" selected disabled>Select City</option>
                            <option *ngFor="let item of cityList" [value]="item.cityId" name="city">
                                {{item?.cityName}}</option>
                        </select>
                        <div *ngIf="addLocationForm.submitted && state.invalid" class="invalid-feedback">
                            <div *ngIf="state.errors.required"><span class="text-danger">City is
                                    required.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="mat-dialog-actions-style ">
        <button type="button" class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
            (click)="resetLocationForm(addLocationForm);clearLocationData()" [disabled]="createLocationButtonLoader"
            mat-dialog-close>Cancel</button>
        <button type="submit" class="flat-butt flat-info-butt flat-info-grad-butt save-btn" [disabled]="isShowAddAirportCode"
            (click)="addLocation(addLocationForm.form)">
            Save Changes
            <span class="ml-3 mr-1" *ngIf="createLocationButtonLoader">
                <i class="fa fa-spin fa-spinner"></i>
            </span>
        </button>
    </mat-dialog-actions>
</form>
